import { render, staticRenderFns } from "./Turmacrud_MudarTurma.vue?vue&type=template&id=7ef1c900&"
import script from "./Turmacrud_MudarTurma.vue?vue&type=script&lang=js&"
export * from "./Turmacrud_MudarTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports